import api from '@/services/api'

export const geteNPSPendencies = async (userId) => {
    try {
        const resp = await api.get(`users/${userId}/profile/pendencies`)
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}

export const getHumorPendencies = async () => {
    try {
        const resp = await api.get(`quiz/verify`)
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}

export const getPendingEvaluations = async (userId) => {
    try {
        const resp = await api.get(
            `/evaluations/${userId}/grouped-by-questionnaires`,
            {
                params: {
                    filter: 'id;questionnaire_id;questionnaire.title',
                    search: `valuer_id:${userId};status:pending`,
                    and: 'yes',
                    with: 'questionnaire',
                },
            }
        )
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}
